import { Button } from "@/lib/components/Button/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/lib/components/DropdownMenu";
import {
  IconDots,
  IconDownload,
  IconPhoto,
  IconTrash,
  IconUpload,
} from "@tabler/icons-react";

function ImageDropdownMenu({
  onUploadClick,
  onReplaceClick,
  onDownloadClick,
  onRemoveClick,
}: {
  onUploadClick: () => void;
  onReplaceClick: () => void;
  onDownloadClick: () => void;
  onRemoveClick?: () => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="iconXs">
          <IconDots size={20} className="text-text-primary" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-64"
        align="end"
        onCloseAutoFocus={(e) => e.preventDefault()}
        onClick={(e) => e.stopPropagation()}
      >
        <DropdownMenuItem
          className="text-sm font-medium"
          onClick={onUploadClick}
        >
          <IconUpload size={18} />
          Upload new image
        </DropdownMenuItem>
        <DropdownMenuItem
          className="text-sm font-medium"
          onClick={onReplaceClick}
        >
          <IconPhoto size={18} />
          Replace with existing image
        </DropdownMenuItem>
        <DropdownMenuSeparator className="border-[#E4E4E4]" />
        <DropdownMenuItem
          className="text-sm font-medium"
          onClick={onDownloadClick}
        >
          <IconDownload size={18} />
          Download image
        </DropdownMenuItem>
        {onRemoveClick && (
          <>
            <DropdownMenuItem
              className="text-sm font-medium text-error"
              onClick={onRemoveClick}
            >
              <IconTrash size={18} />
              Remove end image
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ImageDropdownMenu;
